import React from 'react';
import PropTypes from 'prop-types';
import ShiftDetails from '../ShiftDetails/ShiftDetails';
import Modal from '../Modal/Modal.js';

const NextShiftModal = ({ open, onClose, shift }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      width={480}
      maxHeight="90vh"
      alignContent="left"
      ariaLabelledBy="next-shift-modal"
      variant="default"
    >
      <ShiftDetails shifts={[shift].filter(Boolean)} />
    </Modal>
  );
};

NextShiftModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  shift: PropTypes.object,
};

export default NextShiftModal;
